/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Popup, Space, Text, Icon, Toggle } from '@cashfree-intl/coherent';

import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import { CURRENCY_SYMBOL } from 'utils/constants';
import { EXTERNAL_PMR_HEADINGS } from '../constants';
import { StyledTableCTAItem } from './styled';

const ExternalPMRTable = ({
  data,
  onToggleClick,
  onEditClick,
}: {
  data: any;
  onToggleClick: (index: number) => any;
  onEditClick: (index: number) => any;
}) => {
  const FORMATTED_COLUMN_ID = formatColumns(EXTERNAL_PMR_HEADINGS);

  const currentPageRowData = () =>
    data.map((row, rowIndex) => {
      const formattedRow = {
        ...row,
        id: row.id,
      };

      Object.keys(row).forEach(key => {
        if (key !== 'externalUpfrontTdr') {
          formattedRow[key] = `${CURRENCY_SYMBOL.INR}${row[key]}`;
        } else {
          formattedRow[key] = `${row[key]}%`;
        }
      });
      formattedRow.fixedFee = `${CURRENCY_SYMBOL.INR}${row.fixedFee}`;
      formattedRow.toggle = () => (
        <div>
          <Space alignItems="center" gap={0.75}>
            <Popup
              content={row.active ? 'Disable TDR' : 'Enable TDR'}
              position="bottom right"
              trigger={
                <span>
                  <Toggle
                    active={row.active}
                    onToggle={onToggleClick(rowIndex)}
                    data-event-name="Table_Row_Toggle_ExternalPMRTable"
                    data-ignore-inner-text="true"
                    data-event-properties={JSON.stringify({
                      row_id: rowIndex,
                    })}
                  />
                </span>
              }
            />
            <Text variant="b12" color="bodyLight">
              {row.active ? 'ON' : 'OFF'}
            </Text>
          </Space>
        </div>
      );

      formattedRow.edit = () => (
        <StyledTableCTAItem
          className="table-cta-item"
          onClick={onEditClick(rowIndex)}
          data-event-name="Table_Row_EditExternalPMRTable"
          data-ignore-inner-text="true"
          data-event-properties={JSON.stringify({
            row_id: rowIndex,
          })}
        >
          <Icon name="edit" />
        </StyledTableCTAItem>
      );

      return formattedRow;
    });

  const updatedTableData = currentPageRowData();

  const combinedColumn = [
    {
      accessorKey: 'fixedFee',
      header: '',
      ellipsis: true,
      textAlign: 'right',
      cell: ({ fixedFee }) => fixedFee,
    },
    {
      accessorKey: 'toggle',
      header: ' ',
      ellipsis: true,
      cell: ({ toggle }) => <Space justifyContent="center">{toggle()}</Space>,
    },
    {
      accessorKey: 'edit',
      header: ' ',
      ellipsis: true,
      width: 80,
      textAlign: 'right',
      cell: ({ edit }) => edit(),
    },
  ];

  const updatedColumnId = [
    ...FORMATTED_COLUMN_ID.slice(0, -3),
    ...combinedColumn,
  ];
  return (
    <PaginatedTable
      data={updatedTableData}
      tableHeading={updatedColumnId}
      isPaginated={false}
    />
  );
};

export default ExternalPMRTable;
